<template>
  <Dialog v-model:visible="showModal" class="lg:w-1/3 md:w-2/3 w-2/3 d2-dialog-mobile-full bg-white shadow rounded-xl" :modal="true">
    <template #header>
      <div class="w-full text-center d2-dialog-header-title">{{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_title_text']}}</div>
    </template>
    <ul class="flex-1 space-y-6 d2-dialog-content-mx">
        <li v-if="invoicesData.card_no != ''">
          <p class="text-gray-700 font-medium">{{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_bind_card_credit_text']}}</p>
          <p class="text-gray-500 text-sm flex flex-wrap justify-start">
            <span>{{ invoicesData.card_no }}</span>
            <a href="javascript:void(0);" class="text-blue-500 underline ml-4 text-sm" @click="payPlan()">{{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_bind_card_credit_update_text']}}</a>
          </p>
        </li>
        <li class="space-y-4">
          <p class="text-gray-700 font-medium">
            <span>{{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_invoice_info_text']}}</span>
            <a
              href="javascript:void(0);"
              class="text-blue-500 underline ml-4 font-normal text-sm"
              @click="isEdit=true"
            >{{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_invoice_info_update_text']}}</a>
          </p>
          <div class="mb-4">
            <label class="block text-sm text-gray-700" for="firstName">
              {{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_invoice_info_identifier_text']}}
            </label>
            <input
              class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
              type="text"
              v-model="invoicesData.identifier"
              v-if="isEdit"
            />
            <span v-else class="text-gray-500">{{ invoicesData.identifier }}</span>
          </div>
          <div class="mb-4">
            <label class="block text-sm text-gray-700" for="firstName">
              {{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_invoice_info_name_text']}}
              <span class="font-bold">{{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_invoice_info_name_text_info']}}</span>
            </label>
            <input
              class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
              type="text"
              v-model="invoicesData.name"
              v-if="isEdit"
            />
            <span v-else class="text-gray-500">{{ invoicesData.name }}</span>
          </div>
          <div class="mb-4">
            <label class="block text-sm text-gray-700" for="firstName">
              {{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_invoice_info_address_text']}}
            </label>
            <input
              class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
              type="text"
              v-model="invoicesData.address"
              v-if="isEdit"
            />
            <span v-else class="text-gray-500">{{ invoicesData.address }}</span>
          </div>
          <div class="mb-4">
            <label class="block text-sm text-gray-700" for="firstName">
              {{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_invoice_info_phone_text']}}
            </label>
            <input
              class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
              type="text"
              v-model="invoicesData.mobile"
              v-if="isEdit"
            />
            <span v-else class="text-gray-500">{{ invoicesData.mobile }}</span>
          </div>
          <div class="mb-4">
            <label class="block text-sm text-gray-700" for="firstName">
              {{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_invoice_info_email_text']}}
            </label>
            <input
              class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
              type="text"
              v-model="invoicesData.email"
              v-if="isEdit"
            />
            <span v-else class="text-gray-500">{{ invoicesData.email }}</span>
          </div>
        </li>
      </ul>
    <template #footer>
      <div class="d2-btn-row" style="justify-content: flex-end;">
        <button
          class="d2-btn-ghost"
          @click="showModal=false;isEdit=false;">{{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_invoice_info_cancel_button_text']}}</button>
        <button
          class="d2-btn d2-btn-yellow"
          @click="save_invoices()">{{lang['components']['Dialog']['PaymentInfoDialog']['payment_info_invoice_info_save_button_text']}}</button>
      </div>
    </template>
  </Dialog>

  <!-- ECPay 付款彈窗 -->
  <Dialog v-model:visible="showEcpayModal" class="w-4/5 lg:w-3/5 bg-white shadow rounded-xl" :modal="true" :closable="true">
    <template #header>
      <div class="w-full d2-dialog-header-title">綁定新信用卡</div>
    </template>
    <div class="py-4">
      <div id="ECPayPayment" style="min-height: 400px;"></div>
    </div>
    <template #footer>
      <div class="d2-btn-row" style="justify-content: flex-end;">
        <button
          class="d2-btn-ghost"
          @click="showEcpayModal = false"
        >
          取消
        </button>
        <button
          class="d2-btn d2-btn-primary"
          :disabled="isSubmittingPayment"
          @click="submitEcpayPayment"
        >
          <span v-if="isSubmittingPayment">處理中...</span>
          <span v-else>確認付款</span>
        </button>
      </div>
    </template>
  </Dialog>
</template>

<script>
  import Dialog from 'primevue/dialog';
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import axios from 'axios'
  import Qs from 'qs'

  export default {
    name: 'PaymentInfoDialog',
    components: {
      Dialog
    },
    props: {
      show: {
        type: Boolean,
        default: false
      },
      invoices:{
        type:Object,
        required:true
      },
      memberId: {
        type: Number,
      },
      borderStyle: {
        type: Number,
      },
      info: {
        type: Object,
        default: () => ({
          taxId: 'taxId',
          name: 'name',
          address: 'address',
          phoneNumber: 'phoneNumber',
          email: 'email',
        })
      },
      lang: {
        type: Object
      },
    },
    data() {
      return {
        isEdit: false,
        showEcpayModal: false,
        ecpaySdkLoaded: false,
        isSubmittingPayment: false
      }
    },
    methods: {
      save_invoices(){
        let formData = this.invoicesData;

        axios
          .post('https://www.autoturn.net/api/data/invoices_update.php', Qs.stringify({
            s_code: this.$route.params.id,
            form_data: formData,
            type: this.borderStyle
          }))
          .then((response) => {
            // if(response.data.status == 'success'){
            if(response.data.status == 'login'){
              Swal.fire({
                icon: 'error',
                title: "修改發票資訊",
                text: response.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: '確定'
                // denyButtonText: `Don't save`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  // this.allPageLoading = true
                  window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  // this.allPageLoading = true
                  window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                }
              })
            } else {
              this.$swal(response.data.info);
              this.$emit('childIsPayEmptyInvoice', response.data.isPay_emptyInvoice);
              this.showModal = false;
              this.isEdit = false;
            }
            // }
          });
      },

      payPlan(){
              Swal.fire({
                title: this.lang['components']['Dialog']['PaymentInfoDialog']['axios']['swal_title'],
                html: this.lang['components']['Dialog']['PaymentInfoDialog']['axios']['total_amount_default_text_a'],
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.lang['components']['Dialog']['PaymentInfoDialog']['axios']['yes_button'],
                cancelButtonText: this.lang['components']['Dialog']['PaymentInfoDialog']['axios']['no_button'],
              }).then((result) => {
                if (result.isConfirmed) {
            this.deleteAndRebind();
          }
        })
      },

      // Step 1: 刪除舊卡
      async deleteAndRebind(){
        Swal.fire({
          title: '處理中',
          text: '正在刪除舊的信用卡綁定...',
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => { Swal.showLoading() }
        })

        try {
          const deleteResponse = await axios.post('https://www.autoturn.net/api/pay_card_delete.php', Qs.stringify({
            s_code: this.$route.params.id
          }))

          if(deleteResponse.data.status == 'success'){
            const memberData = deleteResponse.data.member_data;
            const isExpired = memberData.is_expired;
            const chargeAmount = isExpired ? memberData.PeriodAmount : 5;
            const chargeMsg = isExpired
              ? '方案已到期，重新綁卡將刷卡 NT$' + memberData.PeriodAmount + ' 作為方案續約費用'
              : '方案尚未到期，重新綁卡將刷卡 NT$5 作為信用卡驗證';

            const confirmResult = await Swal.fire({
              icon: 'info',
              title: '舊卡已解除綁定',
              text: chargeMsg,
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: '繼續綁卡',
              cancelButtonText: '取消'
            });

            if (!confirmResult.isConfirmed) return;

            // Step 2: 取得新的綁卡 Token（用正確金額）
            await this.getBindCardToken(memberData, chargeAmount);
          } else {
            Swal.fire({
              icon: 'error',
              title: '刪除失敗',
              text: deleteResponse.data.info
            })
          }
        } catch (error) {
          console.error('刪除綁定信用卡失敗:', error);
          Swal.fire({
            icon: 'error',
            title: '刪除失敗',
            text: '無法連線到伺服器，請稍後再試'
          })
        }
      },

      // Step 2: 取得綁卡 Token
      async getBindCardToken(memberData, chargeAmount){
        try {
          const response = await axios.post('https://www.autoturn.net/udnapi/account_info/create_hidden_data_v3.php', Qs.stringify({
            member_id: memberData.member_id,
            currency: memberData.currency,
            price: chargeAmount,
            plan_title: memberData.plan_title,
            plan_id: memberData.plan_id,
            hash: this.$route.params.id
          }))

          if(response.data.status === 'success'){
            this.loadEcpaySdk(response.data.data);
          } else {
            Swal.fire({
              icon: 'error',
              title: '取得付款資訊失敗',
              text: response.data.info
            })
          }
        } catch (error) {
          console.error('取得 Token 失敗:', error);
          Swal.fire({
            icon: 'error',
            title: '取得付款資訊失敗',
            text: '無法連線到伺服器，請稍後再試'
          })
        }
      },

      // Step 3: 載入 ECPay SDK
      loadEcpaySdk(data) {
        // 先顯示付款彈窗
        this.showEcpayModal = true;

        if (this.ecpaySdkLoaded) {
          this.initEcpayPayment(data.Token);
          return;
        }

        if (!window.jQuery) {
          const jqueryScript = document.createElement('script');
          jqueryScript.src = 'https://code.jquery.com/jquery-3.5.1.min.js';
          jqueryScript.onload = () => {
            this.loadEcpaySdkScript(data);
          };
          document.head.appendChild(jqueryScript);
        } else {
          this.loadEcpaySdkScript(data);
        }
      },

      loadEcpaySdkScript(data) {
        const script = document.createElement('script');
        script.src = data.SdkUrl;
        script.onload = () => {
          this.ecpaySdkLoaded = true;
          this.initEcpayPayment(data.Token);
        };
        script.onerror = () => {
          Swal.fire({
            icon: 'error',
            title: '載入失敗',
            text: '無法載入付款元件，請重新整理頁面後再試'
          });
          this.showEcpayModal = false;
        };
        document.head.appendChild(script);
      },

      initEcpayPayment(token) {
        this.$nextTick(() => {
          const container = document.getElementById('ECPayPayment');
          if (!container) {
            console.error('ECPay 容器元素不存在');
            return;
          }

          if (window.ECPay) {
            const serverType = 'Prod'; // 正式環境

            window.ECPay.initialize(serverType, 1, function(errMsg) {
              if (errMsg) {
                console.error('ECPay 初始化錯誤:', errMsg);
                Swal.fire({ icon: 'error', title: '付款元件初始化失敗', text: errMsg });
                return;
              }

              var lang = window.ECPay.Language.zhTW;
              window.ECPay.addBindingCard(token, lang, function(bindErrMsg) {
                if (bindErrMsg) {
                  console.error('ECPay 綁定信用卡畫面錯誤:', bindErrMsg);
                  Swal.fire({ icon: 'error', title: '載入付款畫面失敗', text: bindErrMsg });
                }
              });
            });
          } else {
            console.error('ECPay SDK 未載入');
          }
        });
      },

      // Step 4: 提交綁卡付款
      submitEcpayPayment() {
        if (!window.ECPay) {
          Swal.fire({ icon: 'error', title: '錯誤', text: '付款元件尚未載入' });
          return;
        }

        this.isSubmittingPayment = true;
        const self = this;

        if (typeof window.ECPay.getBindCardPayToken === 'function') {
          window.ECPay.getBindCardPayToken(function(paymentInfo, errMsg) {
            if (errMsg) {
              self.isSubmittingPayment = false;
              Swal.fire({ icon: 'error', title: '付款失敗', text: errMsg });
              return;
            }

            if (paymentInfo) {
              self.completeBindCardPayment(paymentInfo);
            }
          });
        } else {
          this.isSubmittingPayment = false;
          Swal.fire({ icon: 'warning', title: 'ECPay SDK 錯誤', text: '找不到 getBindCardPayToken 方法' });
        }
      },

      // Step 5: 完成綁卡付款
      async completeBindCardPayment(paymentInfo) {
        try {
          Swal.fire({
            title: '處理中',
            text: '正在處理您的付款，請稍候...',
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => { Swal.showLoading() }
          });

          const response = await axios.post('https://www.autoturn.net/udnapi/account_info/create_bindcard_payment.php', Qs.stringify({
            bind_card_pay_token: paymentInfo.BindCardPayToken,
            merchant_trade_no: paymentInfo.MerchantTradeNo,
            member_id: this.memberId
          }));

          this.isSubmittingPayment = false;

          if (response.data.status === 'success') {
            if (response.data.need3D && response.data.threeDURL) {
              window.location.href = response.data.threeDURL;
              return;
                    }

            this.showEcpayModal = false;
            Swal.fire({
              icon: 'success',
              title: '綁卡成功',
              text: '您的信用卡已更新！',
              confirmButtonText: '確定'
            }).then(() => {
              window.location.reload();
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: '付款失敗',
              text: response.data.info || '付款處理失敗'
            });
                }
        } catch (error) {
          this.isSubmittingPayment = false;
          console.error('完成付款失敗:', error);
          Swal.fire({
            icon: 'error',
            title: '付款失敗',
            text: '無法連線到付款伺服器'
          });
        }
      }
    },
    computed: {
      showModal: {
        get: function () {
          return this.show
        },
        set: function (value) {
          this.$emit('update:show', value)
        }
      },
      infoData: {
        get: function () {
          return this.info
        },
        set: function (value) {
          this.$emit('update:infoData', value)
        }
      },
      invoicesData: {
        get: function () {
          return this.invoices
        },
        set: function (value) {
          this.$emit('update:invoicesData', value)
        }
      }
    }
  }
</script>

<style lang="scss" scope>

</style>
